export default __webpack_public_path__ + "static/media/3.20321296.png";